import CheckIcon from "../../../../../assets/icons/common/toggleable/IconCheck";
import PartialIcon from "../../../../../assets/icons/common/toggleable/IconIncomplete";
import CrossIcon from "../../../../../assets/icons/common/toggleable/IconClose";
import Grid from "@mui/material/Grid";
import React from "react";
import { requiredValidator } from "../../../../../services/validationRules";
import Group from "../../../../Wizard/Group";

const AdministrativeDecisionStatusClient = () => {
  return (
    <Grid size={12}>
      <Group
        type={"radio"}
        name={"administrativeDecisionStatusClient"}
        question={"Wie ist der aktuelle Stand der Forderung aus Ihrer Sicht?"}
        options={[
          {
            labelText: "Ihren Anforderungen wurde voll entsprochen.",
            labelIcon: <CheckIcon />,
            labelIconActive: <CheckIcon active />,
            value: "fullyAgreed",
          },
          {
            labelText: "Ihren Anforderungen wurde nur teilweise entsprochen.",
            labelIcon: <PartialIcon />,
            labelIconActive: <PartialIcon active />,
            value: "partiallyAgreed",
          },
          {
            labelText: "Ihre Anforderungen wurden abgelehnt.",
            labelIcon: <CrossIcon />,
            labelIconActive: <CrossIcon active />,
            value: "notAgreed",
          },
        ]}
        validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
      />
    </Grid>
  );
};
export default AdministrativeDecisionStatusClient;
